import {serverCall} from "@/redux/apis/http";
import {DOB_VERIFICATION} from "@/redux/rtk/students/types";
import {USER_REGISTRATION} from "@/components/admin/login/types";

export const getActiveCycles = async () => {
    return await serverCall({
        type: "get",
        timeout: 1,
        endpoint: "/getActiveCycles",
        apiDir: `webapi/shared`,
    }, null)
}

export const verifyDOBIfEligible = async (data: DOB_VERIFICATION) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/verifyDOBIfEligible",
        apiDir: `webapi/shared`,
    }, null)
}

export const processStudentRegistration = async (data: USER_REGISTRATION) => {
    return await serverCall({
        type: "post",
        data: {
            ...data
        },
        timeout: 1,
        endpoint: "/processStudentRegistration",
        apiDir: `webapi/shared`,
    }, null);
}

export const getSiteSettingsForUsers = async (dataType: number) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
            dataType,
        },
        endpoint: "/getSiteSettingsForUsers",
        apiDir: `webapi/shared`,
    }, null)
}